<template>
  <div>
    <template>
      <ex-card disable-offsets>
        <template slot="header">
          <v-dialog v-model="linkDialog" persistent max-width="600">
            <v-card>
              <v-card-title class="headline">{{ (linkSwitch) ? 'Link' : 'Unlink' }} this product </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-switch
                  class="mx-4"
                  v-model="linkSwitch"
                  :label="(linkSwitch) ? 'Link' : 'Unlink'"
                ></v-switch>
                <v-combobox
                  v-model="linkClients"
                  chips
                  clearable
                  multiple
                  solo
                  :items="$store.state.globalModule.clients"
                  :label="linkSwitch ? 'Link from client' : 'Unlink to client'"
                  id="clients"
                  item-text="text"
                  item-value="value"
                  class="custom_combobox mt-1"
                  background-color="rgba(48, 127, 255, 0.1)"
                />
                <v-btn
                  text
                  :ripple="false"
                  class="ex-btn ex-primary-btn text--white mx-3"
                  @click="linkDialog = false"
                >
                  No
                </v-btn>
                <v-btn
                  text
                  :ripple="false"
                  class="ex-btn ex-primary-btn text--white mx-3"
                  @click="link_unlink_to_clients(linkSwitch)"
                >
                  Yes Link It
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <div class="inner">
            <h2>Resolve Conflict</h2>
            <h2>Product Name: {{ productName }}</h2>
            <h2>Clients: {{ clients() }}</h2>
            <div>
               <v-btn
                text
                :ripple="false"
                class="ma-0 ex-btn ex-opacity-btn"
                @click="linkDialog = true"
              >
                Link
              </v-btn>
              <v-btn
                text
                :ripple="false"
                class="ma-0 ex-btn ex-opacity-btn"
                @click="reset()"
              >
                Reset
              </v-btn>
              <v-btn
                text
                :ripple="false"
                :disabled="notConflict"
                class="ma-0 ex-btn ex-opacity-btn"
                @click="goToSaveConflictTable()"
              >
                Save
              </v-btn>
            </div>
          </div>
        </template>
        <div
          class="domain_section my-2"
          v-for="(item, productTotal_index) in productTotal"
          :key="productTotal_index"
        >
          <div class="d-inline-block line-url">
            <span class="d-flex justify-center">{{ item.domain_name }}</span>
          </div>
          <div class="d-inline-block line-dec">
            <v-expansion-panels v-for="(url,url_idx) in item.domain_urls" :key="url_idx">
                <div>
                  left: {{url.l_url_id}} - right : {{ url.r_url_id }}
                </div>
              <v-expansion-panel>
                <div class="d-flex justify-space-around align-center panel-h">
                  <span class="left-span">
                    <span>
                      {{ decodeURI(ifInArray(url.l_url)) }}
                    </span>
                    <!-- kados -->
                    <!-- v-if == some ids are strings and some other int -->
                    <v-btn small fab
                      class="red--text"
                      @click="
                        deleteRow(
                          productTotal_index,
                          url_idx,
                          'left',
                          url.l_url_id,
                          url.r_url_id,
                          item.domain_id
                        )
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </span>
                  <!-- velos -->
                  <v-btn
                    v-if="
                      !(
                        url.r_url_id == url.l_url_id &&
                        (!!url.r_url_id || !!url.l_url_id)
                      )
                    "
                    @click="
                      bookmarkSave(
                        productTotal_index,
                        url.l_url,
                        url.r_url,
                        url.r_url_id,
                        item.domain_id,
                        url.l_url_id,
                        0
                      )
                    "
                    >
                    <v-icon>
                      {{
                        checkUrl(
                          url.l_url,
                          url.r_url
                        )
                      }}
                    </v-icon>
                  </v-btn
                  >
                  <span class="right-span">
                    <!-- kados -->
                    <!-- v-if == some ids are strings and some other int -->
                    <v-btn small fab
                      class="red--text"
                      @click="
                        deleteRow(
                          productTotal_index,
                          url_idx,
                          'right',
                          url.l_url_id,
                          url.r_url_id,
                          item.domain_id
                        )
                      "
                      v-if="
                        url.r_url_id == url.l_url_id &&
                        (!!url.r_url_id || !!url.l_url_id)
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                    <div class="row">
                      <div class="col-12 text-truncate">
                        {{ decodeURI(url.r_url) }}
                      </div>
                    </div>
                    <!-- <span
                      class="col-2 text-truncate"
                    >
                      {{ url.r_url }}
                    </span> -->
                  </span>
                </div>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </ex-card>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
export default {
  name: "ResolveConflictTable",
  props: {
    resolveData: {
      type: [Object, Array],
      default: null,
    },
    productName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // new_test_table_for_preview: [],
      linkClients: [],
      linkSwitch: true,
      linkDialog: false,
      conflictUrl: [],
      product_info: {},
      toDelete: [],
      conflict_array: { left: 0, right: 0, url_id: 0 },
      url_name: { left: "No url", right: "No url" },
      product_id: 0,
      vurl: [],
      testTable: [],
      productTotal: [],
      pending: { type: [Object, Array], default: null },
      conflict: { type: [Object, Array], default: null },
      notConflict: true,
      countOfConflict: 0,
      headers: [
        {
          text: "Conflict Product",
          align: "left",
          sortable: false,
          value: "unsavedProds",
        },
        {
          text:
            `Product Name: ${this.productName} Clients: ${this.clients()}`,
          sortable: false,
          value: "nameProds",
        },
      ],
    };
  },
  mounted() {
    //   alert(this.$store.state.productModule.conflictContainer.clients[0]);
    console.log("products", this.prurls);
    if (this.prurls.length > 0) {
      console.log(
        "myprod",
        this.$store.state.productModule.conflictContainer.merge_container[0]
          .product_conflict.product_domains
      );
      // for (let ml = 0; ml < this.prurls.length; ml++) {
      for (let [key, value] of Object.entries(
        this.$store.state.productModule.conflictContainer.merge_container[0]
          .product_conflict.product_domains
      )) {
        var foundIndex = this.prurls.findIndex(
          (x) => x.domain_id == value.domain_id
        );
        if (foundIndex >= 0) {
          for (
            let s = 0;
            s <
            this.$store.state.productModule.conflictContainer.merge_container[0]
              .product_conflict.product_domains[key].domain_urls.length;
            s++
          ) {
            var urlIndex = this.prurls[foundIndex].domain_urls.findIndex(
              (x) =>
                x.url ==
                this.$store.state.productModule.conflictContainer
                  .merge_container[0].product_conflict.product_domains[key]
                  .domain_urls[s].url
            );
            //  if (urlIndex >= 0) {
            // alert(this.prurls[foundIndex].domain_urls[urlIndex].url)
            // alert(
            //    "There is a problem,probably you select a url from this product."
            //  );
            //  return;
            // }
          }

          console.log(
            "loop",
            this.$store.state.productModule.conflictContainer.merge_container[0]
              .product_conflict.product_domains[key].domain_urls
          );
        }
      }
      
    }
    // }
    console.log("apo proion", this.$store.state.productModule.existProducts);
    console.log("invalidurl", this.$store.state.productModule.responseInvalidUrls ); //ConUrl
    console.log("seturl", this.$store.state.productModule.ConUrl);
    console.log("data", this.$store.state.productModule.conflictContainer);
    this.product_info = this.$store.state.productModule.conflictContainer.merge_container[0].product_conflict.product_info;
    this.product_id = this.$store.state.productModule.conflictContainer.product_id;
    this.pending = this.$store.state.productModule.conflictContainer.merge_container[0].product_pending;
    this.conflict = this.$store.state.productModule.conflictContainer.merge_container[0].product_conflict;
    this.concluse();
    console.log("total products", this.productTotal);
    this.getConflictCount();
    console.log("RESOLVE DATA", this.resolveData);
    // this.new_test_table_for_preview = JSON.parse(JSON.stringify(this.resolveData));
    console.log(
      "RESOLVEstate.urlsContainer",
      this.$store.state.productModule.urlsContainer
    );
    // console.log('addedDomainDuplicates', this.addedDomainDuplicates)
    console.log("addedDomains", this.addedDomains);
    this.productTotal.sort(this.sortDomains); 
  },
  computed: {
    prurls() {
      return this.$store.state.productModule.existProducts;
    },
    pconflict() {
      return JSON.parse(
        JSON.stringify(this.$store.state.productModule.conflictContainer)
      );
      //  return this.$store.getters["productModule/myConclict"];
    },
    ifInArray: function () {
      return (value) => {
        if (value === "") return " No url ";
        else return value;
      };
    },
    addedDomains() {
      return this.$store.state.productModule.urlsContainer.product_domains;
    },
    addedDomainDuplicates() {
      return this.$store.state.productModule.responseInvalidUrls.duplicate_products[0].domains.map(
        (domain) => domain[0]
      );
    },
  },
  methods: {
    notify(title, message) {
      this.$notify({
        group: "save",
        title,
        text: message,
        duration: 500,
        speed: 600,
      });
    },
    link_unlink_to_clients(linkSwitch) {
  // keep in [] only the client ids (linkClients.value)
      const clients_ids = this.linkClients.map(x => x.value);

  //create the payload for api
      const task = (linkSwitch) ? 'linkToClients' : 'unlinkFromClients';
      // const task = (linkSwitch) ? 'linkResolvedProduct' : 'unlinkResolvedProduct';
      const payload = {
          clients: clients_ids,
          product_ids : [this.product_id],
        }
      console.log('send - ', { task, payload })
      this.$store.dispatch("productModule/productApi", { task, payload })
      .then((res) => {
        this.notify("Link to client", "Client saved!");
        console.log('link-unlink results', res )
        // if(linkSwitch){
        //   this.$store.commit("productModule/SET_LINKED_CLIENTS", )
        // } else {
        //   this.$store.commit("productModule/SET_LINKED_CLIENTS", )
        // }
      }).catch((err) => {
        this.notify("Error", "Client dont linked!");
      });

  // reset values
      this.linkDialog = false;
      this.linkClients = [];
    },
    sortDomains(a,b) {
      // console.log(a.domain_name,'-',b.domain_name)
      let aName = a.domain_name.replace('https://','').replace('http://','').replace('www.','');
      let bName = b.domain_name.replace('https://','').replace('http://','').replace('www.','');
      // console.log(aName, bName)
      if ( aName < bName ){
        return -1;
      }
      if ( aName > bName ){
        return 1;
      }
      return 0;
    },
    clients() {
      // alert(this.$store.state.productModule.conflictContainer.clients[0])
      let myclients = "";
      for (
        let i = 0;
        i < this.$store.state.productModule.conflictContainer.clients.length;
        i++
      ) {
        //alert(this.$store.state.productModule.conflictContainer.clients[i]);
        myclients = myclients.concat(
          this.$store.state.productModule.conflictContainer.clients[i] + " , "
        );
      }
      return myclients; //this.$store.state.productModule.conflictContainer.clients;
    },
    checktonerow(left, right) {
      if (left != "" && right === "") {
        return true;
      } else return false;
    },
    checktworows(left, right) {
      if (left != "" && right != "") {
        return true;
      } else return false;
    },
    deleteRow(foundIndex, domain_url_index, type, l_id, r_id, domain_id) {
      if (type == "left") {
        this.productTotal[foundIndex].domain_urls[domain_url_index].l_url = "";
        this.productTotal[foundIndex].domain_urls[domain_url_index].l_url_id = 0;
      } else if ( type == "right" ){
        this.productTotal[foundIndex].domain_urls[domain_url_index].r_url = "";
        this.productTotal[foundIndex].domain_urls[domain_url_index].r_url_id = 0;
      }

      // old_code //
      // var foundIndex = this.productTotal.findIndex(
      //   (x) => x.domain_id == domain_id
      // );
      // for (
      //   let i = 0;
      //   i < this.productTotal[foundIndex].domain_urls.length;
      //   i++
      // ) {
      //   if (this.productTotal[foundIndex].domain_urls[i].r_url_id == l_id
      //       && !!this.productTotal[foundIndex].domain_urls[i].r_url_id) {
      //     if (type == "left") {
      //       this.productTotal[foundIndex].domain_urls[i].l_url = "";
      //       this.productTotal[foundIndex].domain_urls[i].l_url_id = 0;
      //     } else if (type == "right") {
      //       var foundIndex = this.productTotal.findIndex(
      //         (x) => x.domain_id == domain_id
      //       );

      //       for (
      //         let i = 0;
      //         i < this.productTotal[foundIndex].domain_urls.length;
      //         i++
      //       ) {
      //         if (
      //           this.productTotal[foundIndex].domain_urls[i].r_url_id == l_id
      //           && !!this.productTotal[foundIndex].domain_urls[i].r_url_id
      //         ) {
      //           this.productTotal[foundIndex].domain_urls[i].r_url = "";
      //           this.productTotal[foundIndex].domain_urls[i].r_url_id = 0;
      //         }

      //       }
      //     }
      //   }
      // }
      console.log('remove - type', type);
      console.log('remove - conflictUrl', this.conflictUrl);
      console.log('remove - conflictUrl.filtered', this.conflictUrl.filter(el => el != ((type == "left") ? l_id : r_id) ));
      console.log('remove - left', l_id);
      console.log('remove - right', r_id);
      this.conflictUrl = this.conflictUrl.filter(el => el != ((type == "left") ? l_id : r_id) ) ;
      //old_code 
      // const index = (type == "left") ? this.conflictUrl.indexOf(parseInt(l_id)) : this.conflictUrl.indexOf(parseInt(r_id)) ;
      // console.log('index of conflictUrl to delete', index);

      // if (index > -1) {
      //   this.conflictUrl.splice(index, 1); // 2nd parameter means remove one item only
      // }


      this.notConflict = !!this.conflictUrl.length; // enable save button //old_code//this.enabled();
      // console.log(this.conflict_array);
    },
    enabled() {
      this.notConflict = !!this.conflictUrl.length; //(this.conflictUrl.length > 0) ? true : false ;
      //old_code//
      // let conflict_url_length = this.conflictUrl.length;
      // // alert(conflict_url_length)
      // if (conflict_url_length > 0) {
      //   this.notConflict = true;
      // } else {
      //   this.notConflict = false;
      // }
    },
    bookmarkSave(product_Total_index, left_url, right_url, right_id, domain_id, left_id, index) {
      // var foundIndex = this.productTotal.findIndex(
      //   (x) => x.domain_id == domain_id
      // );
      // alert(foundIndex)
      //  for (
      //  let i = 0;
      //  i < this.productTotal[foundIndex].domain_urls.length;
      //   i++
      // ) {
      //if (this.productTotal[foundIndex].domain_urls[i].r_url_id == id) {
      this.productTotal[product_Total_index].domain_urls[index].r_url = left_url;
      this.productTotal[product_Total_index].domain_urls[index].l_url = right_url;
      this.productTotal[product_Total_index].domain_urls[index].l_url_id = right_id;
      this.productTotal[product_Total_index].domain_urls[index].r_url_id = left_id;
      //  alert(this.productTotal[foundIndex].domain_urls[indx].r_url_id);

      // console.log(this.productTotal[foundIndex].domain_urls[i]);
      //  }
      // }

      //  console.log(this.vurl);
    },
    checkUrl(left, right) {
      let mreturn = "<---->";
      if (left === "" && right != "") {
        mreturn = "west";
      }
      if (left != "" && right === "") {
        mreturn = "east";
      }
      return mreturn;
    },
    concluse() {
      // this.product_id = this.pending.product_domains[0].product_id;
      console.log("pending", this.pending.product_domains);
      for (let [key, value] of Object.entries(this.pending.product_domains)) {
        let domain_id = value.domain_id;
        let domain_name = value.domain_name;
        let subarray = new Array();
        for (let [m, v] of Object.entries(value.domain_urls)) {
          subarray.push({
            l_url: v.url,
            l_url_id: v.url_id,
            domain_id: value.domain_id,
            r_url: "",
            r_url_id: 0,
          });
        }

        this.productTotal.push({
          domain_id: domain_id,
          domain_name: domain_name,
          domain_urls: subarray,
        });
      }
      console.log("my urls", this.prurls);

      for (let [key, value] of Object.entries(this.conflict.product_domains)) {
        var foundIndex = this.productTotal.findIndex(
          (x) => x.domain_id == value.domain_id
        );

        if (foundIndex === -1) {
          let domain_id = value.domain_id;
          let domain_name = value.domain_name;
          let subarray = new Array();
          for (let [m, v] of Object.entries(value.domain_urls)) {
            let msellers = new Array();
            for (var i = 0; i < v.sellers.length; i++) {
              msellers.push({
                seller_id: v.sellers[i].seller_id,
                track_id: v.sellers[i].track_id,
              });
            }

            subarray.push({
              l_url: "",
              l_url_id: 0,
              r_url: v.url,
              r_url_id: `${v.url_id}`,
              domain_id: value.domain_id,
              sellers: msellers,
            });
          }
          this.productTotal.push({
            domain_id: domain_id,
            domain_name: domain_name,
            domain_urls: subarray,
          });
        } else {
          for (let [m, v] of Object.entries(value.domain_urls)) {
            for (
              let i = 0;
              i < this.productTotal[foundIndex].domain_urls.length;
              i++
            ) {
              if (
                this.productTotal[foundIndex].domain_urls[i].l_url_id ==
                v.url_id
              ) {
                let ksellers = new Array();
                for (var l = 0; l < v.sellers.length; l++) {
                  ksellers.push({
                    seller_id: v.sellers[l].seller_id,
                    track_id: v.sellers[l].track_id,
                  });
                }
                this.productTotal[foundIndex].domain_urls[i].r_url = v.url;
                this.productTotal[foundIndex].domain_urls[i].r_url_id =
                  v.url_id;
                this.productTotal[foundIndex].domain_urls[i].sellers = ksellers;
                this.conflictUrl.push(v.url_id);
                continue;
              }
            }
            var myIndex = this.productTotal[foundIndex].domain_urls.findIndex(
              (x) => x.l_url_id == v.url_id
            );
            if (myIndex == -1) {
              // let subarray = new Array();

              let rsellers = new Array();
              for (var i = 0; i < v.sellers.length; i++) {
                rsellers.push({
                  seller_id: v.sellers[i].seller_id,
                  track_id: v.sellers[i].track_id,
                });
              }

              this.productTotal[foundIndex].domain_urls.push({
                l_url: "",
                l_url_id: 0,
                r_url: v.url,
                r_url_id: `${v.url_id}`,
                domain_id: value.domain_id,
                sellers: rsellers,
              });
            }
          }
        }
      }
      //alert(this.prurls.length)
      if (this.prurls.length > 0) {
        for (let ml = 0; ml < this.prurls.length; ml++) {
          var prfoundIndex = this.productTotal.findIndex(
            (x) => x.domain_id == this.prurls[ml].domain_id
          );
          if (prfoundIndex === -1) {
            let domain_id = this.prurls[ml].domain_id;
            let domain_name = this.prurls[ml].domain_name;
            let subarray = new Array();
            for (let k = 0; k < this.prurls[ml].domain_urls.length; k++) {
              let msellers = new Array();

              for (
                var m = 0;
                m < this.prurls[ml].domain_urls[k].sellers.length;
                m++
              ) {
                msellers.push({
                  seller_id:
                    this.prurls[ml].domain_urls[k].sellers[m].seller_id,
                  track_id: this.prurls[ml].domain_urls[k].sellers[m].track_id,
                  old: 1,
                });
              }

              subarray.push({
                l_url: this.prurls[ml].domain_urls[k].url,
                l_url_id: this.prurls[ml].domain_urls[k].url_id,
                r_url: "",
                r_url_id: "",
                domain_id: this.prurls[ml].domain_id,
                sellers: msellers,
              });
            }
            this.productTotal.push({
              domain_id: domain_id,
              domain_name: domain_name,
              domain_urls: subarray,
            });
          } else {
            for (let k = 0; k < this.prurls[ml].domain_urls.length; k++) {
              // let subarray = new Array();

              let rsellers = new Array();
              //  for (var s = 0; s < v.sellers.length; s++) { //itan error
              for (
                var s = 0;
                s < this.prurls[ml].domain_urls[k].sellers.length;
                s++
              ) {
                rsellers.push({
                  seller_id:
                    this.prurls[ml].domain_urls[k].sellers[s].seller_id,
                  track_id: this.prurls[ml].domain_urls[k].sellers[s].track_id,
                  old: 1,
                });
              }
              var myfoundIndex = this.productTotal[
                prfoundIndex
              ].domain_urls.findIndex(
                (x) => x.r_url == this.prurls[ml].domain_urls[k].url
              );
              //  alert(myfoundIndex)
              if (myfoundIndex == -1) {
                this.productTotal[prfoundIndex].domain_urls.push({
                  l_url: this.prurls[ml].domain_urls[k].url,
                  l_url_id: this.prurls[ml].domain_urls[k].url_id,
                  r_url: "",
                  r_url_id: '0',
                  domain_id: this.prurls[ml].domain_id,
                  //  sellers: rsellers,
                });
              } else {
                //alert(this.productTotal[prfoundIndex].domain_urls[myfoundIndex].l_url)
                this.productTotal[prfoundIndex].domain_urls[
                  myfoundIndex
                ].l_url = this.prurls[ml].domain_urls[k].url;
                this.productTotal[prfoundIndex].domain_urls[
                  myfoundIndex
                ].l_url_id = this.prurls[ml].domain_urls[k].url_id;
                // this.productTotal[prfoundIndex].domain_urls[myfoundIndex]. sellers=rsellers
              }
            }
          }
        }
      }

      console.log("productdata", this.productTotal);
    },
    moveUrl(rowId, index, direction) {
      let obj = {
        rowId: rowId,
        index: index,
        direction: direction,
      };
      let newMergeContainer = {};
      newMergeContainer = JSON.parse(
        JSON.stringify(this.resolveData.merge_container)
      );
      if (obj.direction === "left") {
        let leftUrl =
          newMergeContainer[obj.rowId].linksRaw[obj.index].seller_url;
        let leftTrackId =
          newMergeContainer[obj.rowId].linksRaw[obj.index].track_id;
        let leftUrlId = newMergeContainer[obj.rowId].linksRaw[obj.index].url_id;
        let domainId =
          newMergeContainer[obj.rowId].linksRaw[obj.index].domain_id;
        let extractable =
          newMergeContainer[obj.rowId].linksRaw[obj.index].extractable;
        let featuresEan =
          newMergeContainer[obj.rowId].linksRaw[obj.index].features.ean;
        let featuresSku =
          newMergeContainer[obj.rowId].linksRaw[obj.index].features.sku;
        let variationId =
          newMergeContainer[obj.rowId].linksRaw[obj.index].variation.id;
        let variationValue =
          newMergeContainer[obj.rowId].linksRaw[obj.index].variation.value;
        newMergeContainer[obj.rowId].linksProduct[obj.index].seller_url =
          leftUrl;
        newMergeContainer[obj.rowId].linksProduct[obj.index].track_id =
          leftTrackId;
        newMergeContainer[obj.rowId].linksProduct[obj.index].url_id = leftUrlId;
        newMergeContainer[obj.rowId].linksProduct[obj.index].domain_id =
          domainId;
        newMergeContainer[obj.rowId].linksProduct[obj.index].extractable =
          extractable;
        newMergeContainer[obj.rowId].linksProduct[obj.index].features.ean =
          featuresEan;
        newMergeContainer[obj.rowId].linksProduct[obj.index].features.sku =
          featuresSku;
        newMergeContainer[obj.rowId].linksProduct[obj.index].variation.id =
          variationId;
        newMergeContainer[obj.rowId].linksProduct[obj.index].variation.value =
          variationValue;
        newMergeContainer[obj.rowId].linksRaw[obj.index].seller_url = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].url_id = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].track_id = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].domain_id = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].extractable = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].features.ean = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].features.sku = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].variation.id = "";
        newMergeContainer[obj.rowId].linksRaw[obj.index].variation.value = "";
      } else if (obj.direction === "right") {
        let rightUrl =
          newMergeContainer[obj.rowId].linksProduct[obj.index].seller_url;
        let rightTrackId =
          newMergeContainer[obj.rowId].linksProduct[obj.index].track_id;
        let rightUrlId =
          newMergeContainer[obj.rowId].linksProduct[obj.index].url_id;
        let domainId =
          newMergeContainer[obj.rowId].linksProduct[obj.index].domain_id;
        let extractable =
          newMergeContainer[obj.rowId].linksProduct[obj.index].extractable;
        let featuresEan =
          newMergeContainer[obj.rowId].linksProduct[obj.index].features.ean;
        let featuresSku =
          newMergeContainer[obj.rowId].linksProduct[obj.index].features.sku;
        let variationId =
          newMergeContainer[obj.rowId].linksProduct[obj.index].variation.id;
        let variationValue =
          newMergeContainer[obj.rowId].linksProduct[obj.index].variation.value;
        newMergeContainer[obj.rowId].linksRaw[obj.index].seller_url = rightUrl;
        newMergeContainer[obj.rowId].linksRaw[obj.index].track_id =
          rightTrackId;
        newMergeContainer[obj.rowId].linksRaw[obj.index].url_id = rightUrlId;
        newMergeContainer[obj.rowId].linksRaw[obj.index].domain_id = domainId;
        newMergeContainer[obj.rowId].linksRaw[obj.index].extractable =
          extractable;
        newMergeContainer[obj.rowId].linksRaw[obj.index].features.ean =
          featuresEan;
        newMergeContainer[obj.rowId].linksRaw[obj.index].features.sku =
          featuresSku;
        newMergeContainer[obj.rowId].linksRaw[obj.index].variation.id =
          variationId;
        newMergeContainer[obj.rowId].linksRaw[obj.index].variation.value =
          variationValue;
        newMergeContainer[obj.rowId].linksProduct[obj.index].seller_url = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].url_id = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].track_id = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].domain_id = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].extractable = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].features.ean = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].features.sku = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].variation.id = "";
        newMergeContainer[obj.rowId].linksProduct[obj.index].variation.value =
          "";
      }
      console.log("MOVE CALL", newMergeContainer);
      this.$store.dispatch("productModule/moveUrl", newMergeContainer);
    },
    deleteUrl(rowId, index, direction) {
      let obj = {
        rowId: rowId,
        index: index,
        direction: direction,
      };
      let newMergeContainer = JSON.parse(
        JSON.stringify(this.resolveData.merge_container)
      );
      newMergeContainer[obj.rowId][
        obj.direction === "left" ? "linksRaw" : "linksProduct"
      ][obj.index].seller_url = "";
      newMergeContainer[obj.rowId][
        obj.direction === "left" ? "linksRaw" : "linksProduct"
      ][obj.index].conflict = 0;
      newMergeContainer[obj.rowId][
        obj.direction === "left" ? "linksProduct" : "linksRaw"
      ][obj.index].conflict = 0;
      this.$store.dispatch("productModule/deleteUrl", newMergeContainer);
      this.countOfConflict -= 1;
      if (!this.countOfConflict) {
        this.notConflict = false;
      }
    },
    reset() {
      console.log(
        JSON.stringify(
          this.$store.state.productModule.conflictContainer.merge_container[0]
            .product_pending.product_domains
        )
      );
      this.$emit("resetConflictTable");
      resolve.style.display = "block";
    },
    getConflictCount() {
      console.log('this.resolveData - ',this.resolveData);
      for (let item in this.resolveData.merge_container) {
        console.log('item of first loop on this.resolveData.merge_container', item, this.resolveData.merge_container );
        for (let productItem in this.resolveData.merge_container[parseInt(item)]
          .linksProduct) {
            console.log('this.resolveData.merge_container[item].linksProduct', productItem)
          let conflictValue =
            this.resolveData.merge_container[item].linksProduct[productItem]
              .conflict;
          if (conflictValue) {
            this.countOfConflict += 1;
          }
        }
      }
      console.log('countOfConflict', this.countOfConflict)
    },
    goToSaveConflictTable() {
      // select the right side and the left 
      // prepare the payload and emit it for save

      // let toDelete = this.pconflict;
      let toSend = [];
      let mypending = [];
      mypending.product_domains = [];
      let myconflict = [];
      myconflict.product_domains = [];
      console.log("total", this.productTotal);
      for (let i = 0; i < this.productTotal.length; i++) {
        // this.productTotal[foundIndex].domain_urls.length;
        var sub = this.productTotal[i].domain_urls.filter(
          (x) => x.l_url !== ""
        );
        // elements of the left part
        if (sub.length > 0) {
          //  console.log("sub", sub);
          // alert(sub.length)
          let domain_id = this.productTotal[i].domain_id;
          let domain_name = this.productTotal[i].domain_name;
          let domain_urls = [];
          for (let s = 0; s < sub.length; s++) {
            var obj = {};
            obj["url"] = sub[s].l_url;
            obj["url_id"] = sub[s].r_url_id;
            obj["domain_id"] = domain_id;
            obj["sellers"] = sub[s].sellers;
            domain_urls.push(obj);
          }

          // alert(domain_id)
          mypending.product_domains.push({
            domain_id: domain_id,
            domain_name: domain_name,
            product_id: this.product_id,
            domain_urls: domain_urls,
          });
        }
        var right = this.productTotal[i].domain_urls.filter(
          (x) => x.r_url !== ""
        );
        // alert(right.length);
        if (right.length > 0) {
          //  console.log("sub", sub);
          // alert(sub.length)
          let rdomain_id = this.productTotal[i].domain_id;
          let rdomain_name = this.productTotal[i].domain_name;
          let rdomain_urls = [];
          for (let m = 0; m < right.length; m++) {
            var robj = {};

            robj["url"] = right[m].r_url;
            robj["url_id"] = right[m].r_url_id;
            robj["domain_id"] = rdomain_id;
            robj["sellers"] = right[m].sellers;
            rdomain_urls.push(robj);
          }
          // alert(domain_id)
          myconflict.product_domains.push({
            domain_id: rdomain_id,
            domain_name: rdomain_name,
            product_id: this.product_id,
            domain_urls: rdomain_urls,
          });

          // console.log("left", sub);
        }
      }

      let product_pending = {};
      let product_conflict = {};
      let payload = {};
      Object.assign(product_pending, mypending);
      Object.assign(product_conflict, myconflict);
      product_pending.product_info = this.product_info;
      product_conflict.product_info = this.product_info;
      Object.assign(payload, { product_pending, product_conflict });
      // Object.assign(payload,{x: 3, z: 4, w: 5});

      // console.log("pending", product_pending);
      // console.log("conflict", product_conflict);
      console.log("payload", payload);
      resolve.style.display = "block";
      this.$emit("saveConflictTable", payload);
      console.log('test', toDelete );
      console.log('test', conflict_array );
      console.log('test', conflict );
      //this.$router.push({ name: 'URLs' }) // go to ('/products')
    },
  },
};
</script>

<style scoped>
@import "https://pro.fontawesome.com/releases/v5.10.0/css/all.css";
td {
  text-align: center;
}
.mred {
  color: red;
  text-align: center;
}
.mmouse {
  cursor: pointer;
}
tr {
  /* border: 2px solid red; */
  height: 4em;
  border-top: 1px solid red;
  position: relative;
}

.left-span {
  width: 45%;
}
.right-span {
  width: 45%;
}
.line-url {
  width: 20%;
}
.line-dec {
  width: 79%;
}
.panel-h {
  min-height: 50px;
}
.span-url {
  display: flex;
  justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// src/components/product/ResolveConflictTable.vue